module.exports = __webpack_public_path__ + "img/childfolders.44f02631.svg";